import React from "react";
import { IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import Button from "components/atoms/Button";
import * as Styled from "./styles";

interface DriverEditSaveConfirmationModalProps {
  open: boolean;
  onDismiss: () => void;
  onConfirmSave: () => void | Promise<void>;
}

function DriverEditSaveConfirmationModal({
  open,
  onDismiss,
  onConfirmSave,
}: DriverEditSaveConfirmationModalProps) {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={onDismiss}>
      <Styled.CancelModalContainer>
        <Styled.CancelModalHeader>
          <Styled.CancelModalTitle>{t("save")}</Styled.CancelModalTitle>
          <IconButton size="medium" aria-label={t("close")} onClick={onDismiss}>
            <CloseIcon />
          </IconButton>
        </Styled.CancelModalHeader>

        <Styled.CancelModalBody>
          <Styled.CancelModalMessage>
            {t("mapDriversSaveModalMessage")}
          </Styled.CancelModalMessage>
        </Styled.CancelModalBody>

        <Styled.CancelModalFooter>
          <Button
            variant="text"
            color="primary"
            onClick={onDismiss}
            sx={Styled.continueEditingButtonSx}
          >
            {t("cancelAction")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              Promise.resolve(onConfirmSave()).catch(() => {});
            }}
            sx={Styled.confirmCancelButtonSx}
          >
            {t("mapDriversSaveModalConfirm")}
          </Button>
        </Styled.CancelModalFooter>
      </Styled.CancelModalContainer>
    </Modal>
  );
}

export default React.memo(DriverEditSaveConfirmationModal);
